import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { Link } from "sprout-ui-icons";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
import { MenuItem } from "@sprout/list-navigation/dist/Menu";
import { useClipboard } from "sprout-ui-dom/dist/hooks";
function getMenuItem(supported) {
    return function MenuItemCopy(props) {
        if (!supported) return null;
        return /*#__PURE__*/ _jsx(MenuItem, {
            icon: Link,
            label: `Copy link from ${props.type}`,
            action: "PAGE_COPY_TO_CLIPBOARD"
        });
    };
}
function useMenuItemPageCopy(disabled = false) {
    const { supported , copy  } = useClipboard();
    const handleCopy = useCallback(()=>{
        copy(window.location.href);
        return true;
    }, [
        copy
    ]);
    useActionRegistryGlobalHandler("PAGE_COPY_TO_CLIPBOARD", handleCopy, {
        skip: !supported || disabled
    });
    return useMemo(()=>[
            supported,
            getMenuItem(supported)
        ], [
        supported
    ]);
}
export default useMenuItemPageCopy;
